import { FlexBox } from 'components/atoms'
import { forwardRef, PropsWithChildren } from 'react'

export const SortableWrapper = forwardRef<HTMLDivElement, PropsWithChildren>(
    (props, ref) => (
        <FlexBox
            ref={ref}
            sx={{
                width: '100%',
                flexWrap: 'wrap',
                gap: 1
            }}
        >
            {props.children}
        </FlexBox>
    )
)
SortableWrapper.displayName = 'SortableWrapper'
